import { Box, Typography } from "@mui/material"
import HorizontalBar from "./HorizontalBar"

const ContactUs = () => {
    return(<>
        <Box sx={{ pt: {xs: 10, md: 30}, px: {xs: 4, md: 35} }}>
            <Box display="flex" gap={5} sx={{ px: {sx: 0, md: 2}, flexDirection: {xs: 'column', md: 'row'}, alignItems: 'center', justifyContent: 'center' }} pb={6}>
                {/* <Box display="flex" gap={1} flex="1 1">
                    <iconify-icon icon="mynaui:mobile" width="24" height="24"></iconify-icon>
                    <Typography> +91 85002 53150</Typography>
                </Box> */}
                <Box display="flex" gap={1}>
                    <iconify-icon icon="material-symbols:mail-outline-sharp" width="24" height="24"></iconify-icon>
                    <Typography>admin@vivekbio.com</Typography>
                </Box>
            </Box>
        </Box>
        <Box sx={{ px:{ xs: 4, md: 12} }}><HorizontalBar /></Box>
        <Box sx={{ pb: {xs:7, md: 25}, px: {xs:4, md: 35} }}>
            <Box display="flex" gap={5} pt={6} px={2} sx={{ flexDirection: {xs: 'column', md: 'row'}, alignItems: 'center' }}>
                <Box flex="1 1">
                    <Typography variant='body1' fontWeight="bold" mb={1}>Corporate office</Typography>
                    <Typography variant='subtitle1'>Flat no:406, Kadiri Apurupa Urban, Kondapur, Hyderabad- 500084</Typography>
                </Box>
                <Box flex="1 1">
                    <Typography variant='body1' fontWeight="bold" mb={1}>Plant address</Typography>
                    <Typography variant='subtitle1'>Vivek Bio Products Private Limited, Plot no: 108, Survey No: 79, TSFPZ- Lingampally, Sadashivnagar Mandal, Kamareddy District - 503145</Typography>
                </Box>
            </Box>
        </Box>
    </>)
}

export default ContactUs;